import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import Products from '../Products'
import FashionProducts from '../../storefronts/indumentaria-femenina/FashionProducts'

function PublicProducts() {
  const { activeProfile, loading } = useBusinessSettingsContext()

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionProducts />
  }

  return <Products />
}

export default PublicProducts
